/* eslint-disable no-console */
const debug = msg => {
  if (process.env.NODE_ENV !== 'production') {
    // tslint:disable-next-line:no-console
    console.log(msg)
  }
}

export default debug
